module.exports = __webpack_public_path__ + "static/media/both-down.2e741ff8.png";